export const reactionOptions = {
  like: '👍',
  love: '❤️',
  haha: '😂',
  sad: '😢',
  angry: '😡',
}
